module.exports = __webpack_public_path__ + "img/leave_attendance.c773d4bc.svg";